// src/components/Header.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

// Menü stil ayarları
const menuLink = {
  color: "#fff",
  textDecoration: "none",
  fontSize: "18px",
  padding: "8px 0",
  transition: "color 0.2s",
  position: "relative",
};
const downIcon = { fontSize: "11px", marginLeft: "4px", verticalAlign: "middle" };

function Header() {
  const [isMobile, setIsMobile] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Ekran boyutuna göre mobil kontrolü
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize(); // ilk yüklemede
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header style={{ width: "100%", background: "#1f4e3d", color: "#fff", fontFamily: "Inter, sans-serif", position: "relative" }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 20px",
        height: "100px",
        background: "#1f4e3d",
      }}>
        {/* Logo */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <img src={logo} alt="Minhal Turizm Logo" style={{ height: "100px" }} />
          <span style={{
            fontSize: "28px",
            fontWeight: 500,
            fontFamily: "'Cormorant Garamond', serif",
            color: "#fff",
            letterSpacing: "1px",
          }}>
            MİNHALTURİZM
          </span>
        </div>

        {/* Hamburger Icon (Mobile) */}
        {isMobile ? (
          <div onClick={() => setMenuOpen(!menuOpen)} style={{ fontSize: "26px", cursor: "pointer" }}>
            ☰
          </div>
        ) : (
          // Masaüstü Menü
          <nav>
            <ul style={{
              display: "flex",
              gap: "30px",
              listStyle: "none",
              margin: 0,
              padding: 0,
              fontWeight: "500"
            }}>
              <li><Link to="/hac" style={menuLink}>Hac <span style={downIcon}>▼</span></Link></li>
              <li><Link to="/umre" style={menuLink}>Umre <span style={downIcon}>▼</span></Link></li>
              <li><Link to="/kultur-turlari" style={menuLink}>Kültür Turları</Link></li>
              <li><Link to="/ucak-bileti" style={menuLink}>Uçak Bileti</Link></li>
              <li><Link to="/odeme" style={menuLink}>Ödeme <span style={downIcon}>▼</span></Link></li>
              <li><Link to="/iletisim" style={menuLink}>İletişim</Link></li>
            </ul>
          </nav>
        )}
      </div>

      {/* Mobil Menü Açılır */}
      {isMobile && menuOpen && (
        <nav style={{
          backgroundColor: "#1f4e3d",
          position: "absolute",
          top: "100px",
          left: 0,
          right: 0,
          zIndex: 1000,
          padding: "20px",
          boxShadow: "0px 4px 8px rgba(0,0,0,0.2)"
        }}>
          <ul style={{
            listStyle: "none",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            margin: 0,
            padding: 0,
          }}>
            <li><Link to="/hac" onClick={() => setMenuOpen(false)} style={menuLink}>Hac</Link></li>
            <li><Link to="/umre" onClick={() => setMenuOpen(false)} style={menuLink}>Umre</Link></li>
            <li><Link to="/kultur-turlari" onClick={() => setMenuOpen(false)} style={menuLink}>Kültür Turları</Link></li>
            <li><Link to="/ucak-bileti" onClick={() => setMenuOpen(false)} style={menuLink}>Uçak Bileti</Link></li>
            <li><Link to="/odeme" onClick={() => setMenuOpen(false)} style={menuLink}>Ödeme</Link></li>
            <li><Link to="/iletisim" onClick={() => setMenuOpen(false)} style={menuLink}>İletişim</Link></li>
          </ul>
        </nav>
      )}
    </header>
  );
}

export default Header;
